module.exports = __webpack_public_path__ + "static/media/usuario.86910a5d.png";